export default __webpack_public_path__ + "static/media/dozule15.b9c2044f.jpg";